import { Component } from "react";
import { FormControl } from "react-bootstrap";

export class CustomTextArea extends Component {
    constructor(props) {
        super(props)
        this.state = {
            input: props.value,
        }
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidUpdate(prevProps, _prevState) {
        if (prevProps !== this.props && this.state.input !== this.props.value) {
            this.setState({input: this.props.value})
        }
    }

    handleChange(e) {
        this.setState({
            input: e.target.value,
        }, () => {
            if (this.props.propagateInput) {
                this.props.propagateInput(e.target.value)
            }
        })
    }

    render() {
        return (
            <FormControl {...this.props} as="textarea" value={this.state.input || ''} onChange={this.handleChange}/>
        )
    }
}